type ElementLike = { type: string; lineItemPropertyKey?: string };
type ConfigLike = { faceElements: Array<{ elementConfig?: ElementLike[] }> } | null | undefined;

/**
 * Whether the card or insert being built has the content it needs to be added to the cart.
 * A photo card needs a photo; a text card needs some text (KB uv-inserts/card-added-without-image-via-skip).
 */
export function isCardComplete(options: {
  activeConfig: ConfigLike;
  textByKey: Record<string, string>;
  imageByKey: Record<string, File | null>;
}): boolean {
  const { activeConfig, textByKey, imageByKey } = options;
  if (!activeConfig) return false;

  const elements = activeConfig.faceElements.flatMap((face) => face.elementConfig ?? []);
  const imageKeys = elements.filter((el) => el.type === 'IMAGE_UPLOAD').map((el) => el.lineItemPropertyKey ?? '');
  if (imageKeys.length > 0) {
    return imageKeys.some((key) => imageByKey[key] instanceof File);
  }
  // Only this card's own TEXT keys count: textByKey is never pruned, so text typed on another card lingers.
  const textKeys = elements.filter((el) => el.type === 'TEXT' && el.lineItemPropertyKey).map((el) => el.lineItemPropertyKey as string);
  return textKeys.some((key) => {
    const value = textByKey[key];
    return typeof value === 'string' && value.trim() !== '';
  });
}
